import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import EitherOrBasicModel from "./EitherOrBasicModel";

export default class EitherOrsModel {
  public meta: MetaModel = new MetaModel();
  public data: EitherOrBasicModel[] = [];
}
